import { Grid, Typography } from '@material-ui/core';
import React from 'react';

const Welcome = () => {
  return (
    <Grid container>
      <Grid item xs={12} style={{ textAlign: 'center' }}>
        <img src="../../../images/gnclogo.png" />
        <Typography variant="h3" color="primary">
          Loading...
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Welcome;
